// KWANKGM03140_住宅ローンしっかり審査事前審査申込入力（受付完了） 申込変更
import React from 'react';
import TopArea from '../../molecules/TopArea';
import { StepNavigation as StepType } from '../../types/Template';
import HeadingM from '../../molecules/HeadingM';
import ApplicationInformation from '../../molecules/ApplicationInformation';
import MypageReturn from '../../molecules/MypageReturn';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  ja_name: string;
  is_staff: boolean;
  display_status: boolean;
  guarantors_num: number;
}

const PreExaminationChangeInputHousingLoanFirmlyFinish: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  ja_name,
  display_status,
  is_staff,
  guarantors_num,
}) => {
  // 完了メッセージ
  const setCompletedMsg = () => {
    // 連帯債務者等ありの場合
    if (guarantors_num > 0) {
      return (
        <div className="p-lead">
          事前審査申込の変更を完了しました。
          <br />
          またご登録の連帯債務者等の方に申込内容確認のためのマイページ開設招待メールを送信しました。
          <br />
          連帯債務者等がいる場合、現在は申込処理は完了していません。連帯債務者等による申込内容の確認と同意が完了すると、JAへの申込処理が完了します。
          <br />
          連帯債務者等の確認状況はマイページから確認可能です。
          <br />
          連帯債務者等の方にメールが届かない場合にはマイページから本申込み案件を開き、メールの再送信を行って下さい。
          <br />
          本お取引におけるJAからのメールについては、「no-reply@entry.ja-netloan.jp」からのみ送信されます。
        </div>
      );
    }

    // 連帯債務者等なしの場合
    return (
      <div className="p-lead">
        事前審査申込の変更を完了しました。
        <br />
        本お取引におけるJAからのメールについては、「no-reply@entry.ja-netloan.jp」からのみ送信されます。
      </div>
    );
  };

  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <HeadingM label="事前審査申込変更完了"></HeadingM>
      {setCompletedMsg()}
      <ApplicationInformation ja_name={ja_name} reception_cd={reception_cd} />
      <MypageReturn is_staff={is_staff} />
    </>
  );
};

export default PreExaminationChangeInputHousingLoanFirmlyFinish;
